import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DataProcessingMergeProgressProps } from '../../../types/reduxTypes/dataProcessingMergeProgress';

const createReducer = <T extends SliceCaseReducers<DataProcessingMergeProgressProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingMergeProgressData(state, action) {
    state.dataProcessingMergeProgressData = action.payload;
  }
});

export default reducers;
